export class Emergencyinfo {
  headline: string;
  description: string;
}
